<footer class="footer">
  <div class="footer-content">
    <p>&copy; {{ currentYear }} Autolac 10.0. {{ 'layout.footer.copyright' | translate }}</p>
  </div>
</footer>
